import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";

import { FormControl,  InputAdornment,  TextField } from "@mui/material";
import "./TextInput.scss"
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../store";
import { RootState } from "../../store/reducers";
import { useSelector } from "react-redux";

export default function TextInput(props: any) {
  const { name, label, value, placeholder, handlechange,type,adornmentType,adornmentText,required,options } = props;
  const dispatch = useDispatch();
  const {
 
  } = bindActionCreators(actionCreators, dispatch);
  const state = useSelector((state: RootState) => state.appReducer);
  const { userInfo, freezScreen } = state;
  const appState = useSelector((state: RootState) => state.apiReducer);


  return (

    <div id="TextInput" className="">
      <p className="mb-0 label mb-1 familysora600">{label}</p>
      <FormControl size="small">
        <TextField
          hiddenLabel
          id="filled-hidden-label-small"
          placeholder={placeholder}
          value={value}
          required={required}
          name= {name}
          variant="filled"
          size="small"
          onChange={handlechange}
          type={type ? type : "text"}
          InputProps={
            adornmentType === "endAdornment"
              ? {
                  endAdornment: <InputAdornment position="end">{adornmentText}</InputAdornment>,
                }
              : {}
          }
        />
      </FormControl>
    </div>

  );
}
